const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Dapatkan manfaat premium untuk lebih dari 35 fitur, termasuk Enhancer, Remover, AI Translators, Screen Recorders, dan banyak lagi. Dapatkan semuanya dengan satu harga terjangkau.',
  Upgrade: 'Meningkatkan',
  Tools: 'Peralatan',
  MyProjects: 'Proyek Saya',
  MyAccount: 'Akun saya',
  Subscription: 'Langganan',
  LogOut: 'Keluar',
  PopularTools: 'Alat Populer',
  Enhance: 'Meningkatkan',
  Remove: 'Menghapus',
  Animate: 'Menghidupkan',
  Extract: 'Ekstrak',
  SaveThreeDays:
    'Proyek disimpan selama 3 hari, silakan unduh setelah diproses.',
  All: 'Semua',
  Video: 'Video',
  Image: 'Gambar',
  Audio: 'Audio',
  minutesAgo: 'beberapa menit yang lalu',
  hoursAgo: 'beberapa jam yang lalu',
  daysAgo: 'beberapa hari yang lalu',
  Modified: 'Diubah',
  Order: 'Memesan',
  EarliestToLatest: 'Terlama hingga Terbaru',
  LatestToEarliest: 'Terbaru hingga Terlama',
  NoProject: 'Belum ada proyek. Mulai cepat dengan',
  OnlineTools: 'Alat Daring',
  AIVideoEnhancer: 'Penyempurna Video AI',
  Enhancer4K: 'Satu-klik untuk AI menyempurnakan video hingga 4K online',
  AIPhotoEnhancer: 'Penambah Foto AI',
  AIEnhancerImage:
    'AI menyempurnakan gambar tanpa kehilangan hingga 8X secara online',
  View: 'Melihat',
  Download: 'Unduh',
  MultipleSelect: 'Pilihan ganda',
  Delete: 'Menghapus',
  SubscriptionHistory: 'Riwayat Berlangganan',
  NoValidSubscription: 'Tidak ada langganan yang valid.',
  veContent: 'Satu-klik untuk AI menyempurnakan video hingga 4K online',
  peContent:
    'AI menyempurnakan gambar tanpa kehilangan hingga 8X secara online',
  rmvContent: 'Hapus tanda air dari video',
  rmttContent: 'Hapus tanda air video TikTok dalam sekejap',
  dynamicContent: 'Animasikan foto Anda secara online',
  rmbgContent: 'Hapus latar belakang dari gambar',
  youMayNeed: 'Anda mungkin membutuhkan',
  new: 'Baru',
  loginYourAccount: 'Masuk ke akun HitPaw Anda',
  signUpYourAccount: 'Daftar ke akun HitPaw Anda',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
